import BookingStatusLabelType from '@/shared/constants/booking/BookingStatusLabelType'

const { Open, Confirmed, Pending, Unapproved } = BookingStatusLabelType

export default Object.freeze({
  pendingApproval: Unapproved,
  filled: Confirmed,
  unfilled: Open,
  tentative: Pending,
  rejected: Open,
  multiTentative: Pending,
})
